// extracted by mini-css-extract-plugin
export default {"eventYears":"worldEvents__eventYears___[chunkhash-base64-5]"};